import React, { useEffect, useState } from 'react';
import BackButton from '../components/BackButton';
import Sidebar from '../components/Sidebar';
import MobileNav from '../components/MobileNav';
import huwawei from '../assets/icons8-huawei-24.png';
import google from '../assets/playstore-svgrepo-com.svg'
import apk from '../assets/apk.png'
import apple from '../assets/icons8-apple-50.png'
import { Heart, KeyRound, LockKeyhole, LogOut, User, CircleUserRound, Info } from 'lucide-react';
import { OffCanvas } from '../components/OffCanvas'; // Assuming you have OffCanvas component

export default function Profile() {
    const breakpoint = 768; // Adjust this value as needed

    const [SelectedChannel, setSelectedChannel] = useState(0);
    const [userData, setUserData] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
    const [showOffCanvas, setShowOffCanvas] = useState(false);  // Control offcanvas visibility
    const [offCanvasTitle, setOffCanvasTitle] = useState(''); // Title of offcanvas
    const [iframeUrl, setIframeUrl] = useState(''); // URL for iframe in offcanvas

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < breakpoint);
        };

        window.addEventListener('resize', handleResize);

        // Optional: check immediately
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [breakpoint]);

    useEffect(() => {
        const raw = localStorage.getItem("PK_user");
        if (raw) {
            try {
                const parsed = JSON.parse(raw);
                setUserData(parsed);
            } catch (e) {
                console.error("Failed to parse user data from localStorage");
            }
        }
    }, []);

    // Handle OffCanvas button clicks
    const openOffCanvas = (title, url) => {
        setOffCanvasTitle(title);
        setIframeUrl(url);
        setShowOffCanvas(true);
    };




    const logout = () => {
        console.log("LL")
        localStorage.removeItem('PK_user');
        window.location.href = "/";
      };

      


    return (
        <div className='d-flex'>
            <Sidebar
                SelectedChannel={SelectedChannel}
                onChannelSelect={(index) => setSelectedChannel(index)}
            />

            <section className='body_section flex-grow-1'>
                <BackButton />
                <div className='d-flex flex-row align-items-center justify-content-between' >
                    <h3 className='bold mt-3 text-pink-500'>Profile</h3>
                </div>

                <div className="card text-white p-3 rounded mt-3" style={{ backgroundColor: '#f4f4f4' }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className='w-100' >
                            <div className='d-flex flex-row align-items-center justify-content-between w-100 mb-2' >
                                <h5 className="m-0 text-dark">User</h5>
                                <div className="badge bg-success mt-3">Subscription Active</div>
                            </div>
                            <p><strong className='bold' >User ID:</strong> {userData?.UserID || '-'}</p>
                            <p><strong className='bold' >Phone:</strong> {userData?.phone || '-'}</p>
                        </div>
                    </div>

                    <hr className="border-secondary" />

                    <div className="mb-3">
                        <h5 className='text-dark' >Account Info</h5>
                        <div className="d-flex flex-column gap-3 mt-3">

                            {userData?.showMyAccountDetails ? (
                                <p className="text-dark m-0" style={{ cursor: 'pointer' }} onClick={() => openOffCanvas('Account Details', `https://apis.mymobibox.mobi/API/InAppWAP/MAD/?bcid=${userData.billingChannelId}&MSISDN=${userData?.phone}&langCode=en`)}>
                                    <CircleUserRound color="var(--main-red)" /> Account Details
                                </p>
                            ) : ""}



                            {userData?.showUnsub ? (<p className="text-dark m-0" style={{ cursor: 'pointer' }} onClick={() => openOffCanvas('Unsubscribe', `https://apis.mymobibox.mobi/API/InAppWAP/Uns/?bcid=${userData.billingChannelId}&MSISDN=${userData?.phone}&langCode=en`)}>
                                <Info color="var(--main-red)" /> Unsubscribe
                            </p>
                            ) : ""}


                            {userData?.ShowTC ? (
                                <p className="text-dark m-0" style={{ cursor: 'pointer' }} onClick={() => openOffCanvas('Terms & Conditions', 'https://pikaboo-terms.netlify.app')}>
                                    <KeyRound color="var(--main-red)" /> Terms & Conditions
                                </p>
                            ) : ""}


                            {userData?.ShowPP ? (<p className="text-dark m-0" style={{ cursor: 'pointer' }} onClick={() => openOffCanvas('Privacy Policy', 'https://pikaboo-privacy.netlify.app')}>
                                <LockKeyhole color="var(--main-red)" /> Privacy Policy
                            </p>) : ""}



                        </div>
                    </div>

                    {/* <hr className="border-secondary" />

   

                        <div className="d-flex flex-wrap gap-2 mt-3">
                            <a
                                href="https://appgallery.huawei.com/#/app/C113931503"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn d-flex align-items-center gap-2 btn-secondary"
                                style={{ height: '40px' }}
                            >
                                <img src={huwawei} alt="Huawei" style={{ height: '24px' }} />
                                <div className="d-flex flex-column align-items-start" style={{ lineHeight: '1', fontSize: '12px' }}>
                                    <span className="fw-light">Get it on</span>
                                    <span className="fw-bold">AppGallery</span>
                                </div>
                            </a>

                            

                            <a
                                href="https://apps.apple.com/us/app/smart-pikaboo/id6744148320"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn d-flex align-items-center gap-2 btn-secondary"
                                style={{ height: '40px' }} >
                                <img src={apple} alt="Apple Store" style={{ height: '24px' }} />
                                <div className="d-flex flex-column align-items-start" style={{ lineHeight: '1', fontSize: '12px' }}>
                                    <span className="fw-light">Get it on</span>
                                    <span className="fw-bold">App Store</span>
                                </div>
                            </a>
                        </div>



                    </div> */}
                    {isMobile ? <button className='btn btn-secondary' onClick={()=>logout()} > <LogOut /> Logout</button> : ""}
                </div>
            </section>

            <MobileNav />

            {/* OffCanvas Component */}
            <OffCanvas
                show={showOffCanvas}
                onClose={() => setShowOffCanvas(false)}
                title={offCanvasTitle}
            >
                <iframe src={iframeUrl} width="100%" height="100%" frameBorder="0" title={offCanvasTitle}></iframe>
            </OffCanvas>
        </div>
    );
}
